import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import api from '../utils/api';
import { UserActionTypes } from '../constants/actionTypes';
import { IUserProfileState } from '../reducers/userReducer';

export interface IUserProfileData {
    userId: string;
    email: string;
    borrower: string;
    name: string;
    whitelistedProducts: IWhitelistedProduct[];
}

export interface IWhitelistedProduct {
    productId: string;
    roles: string[]
}

export type IUserProfileDataAction = {
    type: UserActionTypes.FETCH_USER_PROFILE_DATA;
    userProfileData: IUserProfileData | null;
}

export const getUserProfile: ActionCreator<ThunkAction<Promise<unknown>, IUserProfileState,
    null, IUserProfileDataAction>> = () => async (dispatch: Dispatch) => {
      try {
        const response = await api.get<IUserProfileData>('/gateway/v1/profile');
        const action:IUserProfileDataAction = {
          type: UserActionTypes.FETCH_USER_PROFILE_DATA,
          userProfileData: response.data,
        };
        dispatch(action);
      } catch (err) {
        const action:IUserProfileDataAction = {
          type: UserActionTypes.FETCH_USER_PROFILE_DATA,
          userProfileData: null,
        };
        dispatch(action);
      }
    };
